import { Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { VendorsService } from '../../data/vendors.service';
import { Vendor } from '../../data/vendor';
import { VendorModalComponent } from '../vendor-modal/vendor-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Table } from 'primeng/table';
import { LocalStorage } from 'ngx-webstorage';
import { CustomerService } from 'projects/app-misc/src/app/modules/customer/data/customer.service';
import { Customer } from 'projects/app-misc/src/app/modules/customer/data/customer';
import {
  CustomerWindowComponent
} from 'projects/app-misc/src/app/modules/customer/view/customer-window/customer-window.component';
import { upperCaseValue, capitalizeCaseValue, getValue, takeUntilDestroyed } from 'projects/core/src/public-api';
import moment from 'moment';
import { environment } from 'projects/desktop/src/environments/environment';
import { Subscription, timer, Subject } from 'rxjs';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';

class TableColumnDef {
  field: string
  header: string
  type?: 'Date' | 'number' | 'vendor'
  renderer?: any
}

@Component({
  selector: 'app-vendors-page',
  templateUrl: './vendors-page.component.html',
  styleUrls: ['./vendors-page.component.scss']
})
export class VendorsPageComponent implements OnInit, AfterViewInit, OnDestroy {
  allVendors: Vendor[];
  vendors: Vendor[];

  cols: TableColumnDef[];

  loadingProjects = true;

  projectsPerPage = 15;
  totalElements = 25;

  colsForSearch = [];

  @ViewChild('dt', {static: true})
  vendorsTable: Table;

  @LocalStorage()
  showActiveVendors: boolean;

  first: number;
  rows: number;

  searchString = '';

  loadSubj = new Subject<void>();

  constructor(
    protected el: ElementRef,
    protected dialog: MatDialog,
    protected vendorsService: VendorsService,
  ) {
    this.cols = [
      {field: 'name', header: 'Name', renderer: upperCaseValue},
      {field: 'eMail', header: 'E-Mail'},
      {field: 'phone', header: 'Phone'},
      {field: 'city', header: 'City'},
      {field: 'address1', header: 'Address'}
    ];
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.projectsPerPage = Math.max(this.projectsPerPage, Math.trunc((this.el.nativeElement.offsetHeight - 150) / 40));

      this.loadNewProjects();

      this.countCols();

      this.subToLoadMaterials();
    })
  }

  subToLoadMaterials() {
    this.loadSubj.pipe(debounceTime(500)).subscribe(emit => {
      this.vendors = this.allVendors.filter(vend => {
        const name = vend.name.toLowerCase();
        return name.includes(this.searchString)
      });
    })
  }

  topSearchBar() {
    this.loadSubj.next()
  }

  resetVendors() {
    this.searchString = '';
    this.vendors = [...this.allVendors]
  }

  countCols() {
    this.cols.forEach(col => {
      this.colsForSearch.push(col.field)
    })
  }

  openVendor(event: any) {
    this.openVendorWindow(event.data)
  }

  // loadProjectsLazy(event: any) {
  // 	this.first = event.first;
  // 	this.rows = event.rows;

  // 	this.loadNewProjects();
  // }

  loadNewProjects() {
    this.loadingProjects = true

    this.vendorsService
    .getVendors()
    .subscribe(vendors => {
      this.vendors = vendors;
      this.allVendors = [...vendors]

      this.totalElements = this.vendors.length

      this.loadingProjects = false;
    })
  }

  openVendorWindow(data: Customer) {
    const dialogRef = this.dialog.open(VendorModalComponent, {
      data: {
        id: data.id
      },
      panelClass: 'vendor-window-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadNewProjects();
    });
  }

  getFieldData(rowData: any, col: TableColumnDef) {

    let value = getValue(rowData, col.field)
    if(col.type === 'Date') {
      value = moment(value).format('ll');
    } else if(col.type === 'number') {
      value = Math.round(value * 100) / 100
    }

    if(col.renderer) {
      value = col.renderer(value)
    }
    // if col has renderer, then apply this renderer to value

    return value
  }

  ngOnDestroy() {

  }

}
